import { Card, CardBody, Col, Input, InputGroup, InputGroupText } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { useState } from "react";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { IconsWithPrefixAndPostfixs } from "../../../../Constant";
import { TOUCHSPIN_DATA } from "../../../../Data/FormWidgets";

const IconsWithPrefixAndPostfix = () => {
  const [values, setValues] = useState([0, 0]);
  const handleIncrement = (index: number) => {
    setValues((prevValues) => {
      return prevValues.map((value, i) => (i === index ? value + 1 : value));
    });
  };
  const handleDecrement = (index: number) => {
    setValues((prevValues) => {
      return prevValues.map((value, i) => (i === index && value > 0 ? value - 1 : value));
    });
  };
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={IconsWithPrefixAndPostfixs}  span={TOUCHSPIN_DATA} />
        <CardBody className="common-flex pre-post-touchspin">
          <InputGroup>
            <Btn color="primary" className="decrement-touchspin btn-touchspin" onClick={() => handleDecrement(0)}>
              <i className="fa fa-minus"></i>
            </Btn>
            <InputGroupText>{"$"}</InputGroupText>
            <Input className="input-touchspin spin-outline-primary" type="number" value={values[0]} readOnly />
            <Btn color="primary" className="increment-touchspin btn-touchspin" onClick={() => handleIncrement(0)}>
              <i className="fa fa-plus"> </i>
            </Btn>
          </InputGroup>
          <InputGroup>
            <Btn color="primary" className="decrement-touchspin btn-touchspin" onClick={() => handleDecrement(1)}>
              <i className="fa fa-minus"></i>
            </Btn>
            <Input className="input-touchspin spin-outline-primary" type="number" value={values[1]} readOnly/>
            <InputGroupText className="input-group-text">{"%"}</InputGroupText>
            <Btn color="primary" className="increment-touchspin btn-touchspin" onClick={() => handleIncrement(1)}>
              <i className="fa fa-plus"></i>
            </Btn>
          </InputGroup>
        </CardBody>
      </Card>
    </Col>
  );
};

export default IconsWithPrefixAndPostfix;
